import styled from 'styled-components';

export const Container = styled('div')`

  .minicard-wrapper {
    .list {
      max-height: 100px !important;
      overflow-y: scroll !important;
    }
  }

`;
